import ScrollSync from './ScrollSync';
export default ScrollSync;
export { ScrollSync };


//////////////////
// WEBPACK FOOTER
// ./~/react-virtualized/dist/es/ScrollSync/index.js
// module id = 862
// module chunks = 4